export default {
	appid: 'wx5d7898bd7a24854a',
	Url: "https://gdtv.xinyi-tech.com/#/",
	img: '/static/logoImg/dianshitai.png'
};



// WEBPACK FOOTER //
// ./src/config/modules/pro.js